import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {GestioneRivenditoriComponent} from './gestione-rivenditori';

let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {
  $stateProvider
    .state('home.gestione-rivenditori', {
      url: '/gestione-rivenditori',
      ncyBreadcrumb: {
        label: 'Gestione Rivenditori',
        parent: 'home.admin'
      },
      data: {
        authorisationLevel: 2,
        pageTitle: 'Gestione Rivenditori'
      },
      views: {
        homeContent: {
          template: '<gestione-rivenditori flex="100"></gestione-rivenditori>'
        }
      }
    });
};

stateConfig.$inject = ['$stateProvider'];

export const GestioneRivenditoriModule: string = ng
  .module('gestione-rivenditori', [
    'ui.bootstrap',
    uiRouter
  ])
  .component('gestioneRivenditori', GestioneRivenditoriComponent)
  .config(stateConfig)
  .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/admin/gestione-rivenditori/gestione-rivenditori.module.ts